import { Link } from 'react-router-dom';
import { siteStats } from '@/mocks/homeData';

const faqs = [
  {
    q: '黑料视频的内容来源是什么？',
    a: '我们的内容来自多方渠道，包括一线狗仔投稿、圈内人士匿名爆料、网友投稿以及公开信息的深度挖掘。每一条爆料发布前都会经过团队的多重核实，确保信息的真实性和可靠性。',
  },
  {
    q: '为什么选择凌晨更新？',
    a: '凌晨是信息传播的黄金窗口期。娱乐圈的很多猛料通常在深夜发生，我们选择在凌晨零点准时更新，确保瓜友们能第一时间吃到最新鲜的瓜。同时，这也契合了我们"黑料不打烊"的品牌理念。',
  },
  {
    q: '如何向黑料视频投稿？',
    a: '欢迎通过我们的微博私信、邮箱投稿。所有投稿均严格匿名处理，我们承诺永不透露爆料人信息。对于重大独家爆料，我们将提供相应稿酬。投稿邮箱：tips@heiliaosp.com',
  },
  {
    q: '视频内容会被下架吗？',
    a: '我们严格遵守相关法律法规，所有发布内容均经过法务审核。对于当事人或经纪公司提出的合理诉求，我们会根据事实情况作出相应处理。但我们承诺：绝不因资本和公关压力而删除真实内容。',
  },
  {
    q: '黑料视频有APP吗？',
    a: '目前正在紧锣密鼓地开发中，预计下个季度上线。届时将支持推送通知功能，让你永远不会错过任何一条猛料。敬请期待！',
  },
];

const timelineEvents = [
  {
    year: '2024.03',
    title: '黑料视频正式上线',
    description: '以"拒绝官腔，只爆猛料"为口号，网站正式对外发布，首日即获得5万+访问。',
  },
  {
    year: '2024.06',
    title: '视频总量突破1000条',
    description: '上线仅三个月，凭借高质量内容积累了大量忠实用户，视频库突破四位数。',
  },
  {
    year: '2024.09',
    title: '日活突破10万',
    description: '随着多起独家爆料的发布，网站知名度急剧上升，日活跃用户突破10万大关。',
  },
  {
    year: '2025.01',
    title: '推出分类导航系统',
    description: '为了提升用户体验，推出四大分类导航：明星八卦、网红黑料、暴走视频、内幕大瓜。',
  },
  {
    year: '2025.06',
    title: '评论互动功能上线',
    description: '开放评论区，瓜友们可以在每一条视频下交流和讨论，吃瓜氛围更加热烈。',
  },
  {
    year: '2026.01',
    title: '全网用户突破100万',
    description: '经过近两年的发展，黑料视频已成为国内最具影响力的娱乐八卦平台之一。',
  },
];

export default function About() {
  return (
    <main className="pt-16">
      {/* Hero */}
      <section className="relative py-20 md:py-28 bg-background-50">
        <div className="max-w-[1440px] mx-auto px-4 md:px-6">
          <div className="flex flex-col lg:flex-row gap-16 lg:gap-24">
            <div className="lg:w-auto flex-shrink-0 pt-2">
              <span className="text-xs font-medium text-foreground-700 tracking-widest uppercase">
                / about
              </span>
            </div>
            <div className="flex-1 max-w-3xl">
              <h1 className="text-[clamp(2rem,4vw,3.5rem)] font-black text-foreground-50 tracking-[-0.02em] leading-[1.1] mb-6">
                关于黑料视频
              </h1>
              <p className="text-lg md:text-xl text-foreground-400 font-light leading-relaxed mb-8">
                我们是一群热爱真相的人。在这个被资本和公关精心包装的娱乐圈，我们选择站在真实这一边。黑料视频不只是一家媒体，更是娱乐圈的照妖镜。
              </p>
              <p className="text-base text-foreground-500 leading-relaxed mb-6">
                自 2024 年成立以来，我们始终坚持"拒绝官腔，只爆猛料"的原则，致力于为每一个吃瓜群众提供最真实、最及时、最劲爆的娱乐八卦内容。我们不收钱删帖，不受资本裹挟，不对公关低头。
              </p>
              <p className="text-base text-foreground-500 leading-relaxed">
                截至目前，我们已经累计发布了超过 <strong className="text-primary-400">{siteStats.totalVideos}</strong> 条视频内容，每天有超过 <strong className="text-primary-400">{siteStats.onlineUsers}</strong> 名瓜友在这里蹲守最新猛料。感谢每一位支持我们的吃瓜人。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-16 bg-background-100">
        <div className="max-w-[1440px] mx-auto px-4 md:px-6">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
            <StatCard icon="ri-vidicon-line" value={siteStats.totalVideos} label="视频总量" />
            <StatCard icon="ri-flashlight-line" value={siteStats.dailyUpdate} label="每日更新" />
            <StatCard icon="ri-user-smile-line" value={siteStats.onlineUsers} label="在线瓜友" />
            <StatCard icon="ri-chat-3-line" value={siteStats.totalComments} label="评论总数" />
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="py-20 md:py-28 bg-background-50">
        <div className="max-w-[1440px] mx-auto px-4 md:px-6">
          <div className="text-center mb-16">
            <span className="inline-block px-3 py-1 text-xs font-semibold rounded-full border border-primary-500/40 text-primary-400 mb-4">
              发展历程
            </span>
            <h2 className="text-[clamp(1.8rem,3vw,2.8rem)] font-black text-foreground-50 tracking-[-0.02em]">
              一路走来
            </h2>
          </div>

          <div className="relative max-w-3xl mx-auto">
            {/* Timeline line */}
            <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-200" />

            <div className="space-y-10">
              {timelineEvents.map((event, idx) => (
                <div key={idx} className="relative flex gap-6 pl-[50px]">
                  {/* Dot */}
                  <div className="absolute left-[12px] top-1.5 w-[15px] h-[15px] rounded-full border-2 border-primary-500 bg-background-50 z-10" />

                  <div className="flex-1">
                    <span className="text-xs font-bold text-primary-400 mb-1.5 block">
                      {event.year}
                    </span>
                    <h3 className="text-base font-bold text-foreground-200 mb-1.5">{event.title}</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">{event.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-20 md:py-28 bg-background-100">
        <div className="max-w-[1440px] mx-auto px-4 md:px-6">
          <div className="text-center mb-16">
            <span className="inline-block px-3 py-1 text-xs font-semibold rounded-full border border-accent-500/40 text-accent-400 mb-4">
              常见问题
            </span>
            <h2 className="text-[clamp(1.8rem,3vw,2.8rem)] font-black text-foreground-50 tracking-[-0.02em]">
              你可能想问
            </h2>
          </div>

          <div className="max-w-3xl mx-auto space-y-3">
            {faqs.map((faq, idx) => (
              <FAQItem key={idx} faq={faq} defaultOpen={idx === 0} />
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-background-50">
        <div className="max-w-[1440px] mx-auto px-4 md:px-6 text-center">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-50 mb-4">
            准备好开始吃瓜了吗？
          </h2>
          <p className="text-foreground-500 mb-8 max-w-md mx-auto">
            加入 <strong className="text-primary-400">{siteStats.onlineUsers}</strong> 名瓜友，每天凌晨蹲守最新猛料
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-950 text-sm font-bold rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            回到首页吃瓜
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>
      </section>
    </main>
  );
}

function StatCard({ icon, value, label }: { icon: string; value: string; label: string }) {
  return (
    <div className="p-6 rounded-2xl bg-background-50 border border-background-200/70 text-center">
      <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-xl bg-primary-500/15">
        <i className={`${icon} text-primary-400 text-xl`}></i>
      </div>
      <div className="text-2xl font-black text-foreground-50 tracking-tight">{value}</div>
      <div className="text-xs text-foreground-600 mt-1">{label}</div>
    </div>
  );
}

import { useState } from 'react';

function FAQItem({ faq, defaultOpen }: { faq: typeof faqs[0]; defaultOpen: boolean }) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
      >
        <span className="text-sm font-semibold text-foreground-200 pr-4">{faq.q}</span>
        <span
          className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${
            isOpen ? 'rotate-180' : ''
          }`}
        >
          <i className="ri-arrow-down-s-line text-foreground-500 text-lg"></i>
        </span>
      </button>
      <div
        className={`transition-all duration-300 overflow-hidden ${
          isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <p className="px-6 pb-5 text-sm text-foreground-500 leading-relaxed">{faq.a}</p>
      </div>
    </div>
  );
}